import React from 'react';
import { ChatBubble } from '@parsina/framework';

import { useTranslation } from '../../i18n/I18nProvider.jsx';

// The student's own turn. core.md §9.3.
//
// A tight bubble, `mine`, with the kit's three delivery states — and the glyph
// the kit draws is what distinguishes them, not the colour, so «در حال ارسال»,
// «ارسال شد» and «ارسال نشد» survive a greyscale screen.
//
// A FAILED turn is not stored anywhere: the BFF writes the student turn and the
// answer together, AFTER the AI call returns, so a call that never returned left
// nothing behind (core.md §8.3). The bubble on screen is the only copy of the
// question, which is why «تلاش مجدد» re-sends the same text rather than asking
// the student to type it again.

export default function StudentMessage({ message, onRetry }) {
  const { t, formatTime } = useTranslation();
  const status = message?.status || 'sent';

  return (
    <ChatBubble
      mine
      body={message?.content || ''}
      timeLabel={formatTime(message?.createdAtMs)}
      status={status}
      statusLabel={t(`chat.message.${status === 'pending' ? 'sending' : status}`)}
      pending={status === 'pending'}
      failed={status === 'failed'}
      onRetry={status === 'failed' ? onRetry : undefined}
      retryLabel={t('chat.message.retry')}
      data-testid="student-message"
    />
  );
}
